import React from 'react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {SectionNotification, Text} from 'wix-ui-tpa/cssVars'

import {getMediumDate, getShortTime} from '../../utils/dateString'

import {classes} from './NotAvailableTimeSlotNotification.st.css'

interface Props {
  date: Date
  partySize: number
  regionalSettings?: string
  showTime?: boolean
  textClassName?: string
}

export const NotAvailableTimeSlotNotification: React.FC<Props> = ({
  date,
  partySize,
  regionalSettings,
  showTime = true,
  textClassName,
}) => {
  const {t} = useTranslation()

  const message = showTime
    ? t('uou-reservations.reservations.time-slot-unavailable', {
        number: partySize,
        date: getMediumDate(date, regionalSettings),
        time: getShortTime(date, regionalSettings),
      })
    : t('uou-reservations.reservations.date-unavailable', {
        number: partySize,
        date: getMediumDate(date, regionalSettings),
      })

  return (
    <div style={{margin: '20px 0'}}>
      <SectionNotification className={classes.root}>
        <Text className={textClassName}>{message}</Text>
      </SectionNotification>
    </div>
  )
}
